import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconCheckboxCircleFill.tsx
const IconCheckboxCircleFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M16 29.333C8.634 29.333 2.665 23.364 2.665 16S8.636 2.667 15.999 2.667 29.333 8.636 29.333 16s-5.97 13.333-13.334 13.333m-1.33-8 9.427-9.428-1.886-1.885-7.541 7.543-3.772-3.772-1.885 1.885z"
	})]
});
var IconCheckboxCircleFill_default = forwardRef(IconCheckboxCircleFill);
//#endregion
export { IconCheckboxCircleFill_default as default };
